/**
 * A wrapper for console.log/warn/error/trace etc,
 * which will log only if the environment is development
 */
/* eslint-disable */
export default class DebugLogger {
  constructor() {
    this.debug = {};
    if (!window.console) return () => {};
    if (process.env.NODE_ENV === 'development') {
      Object.keys(console).forEach(m => {
        if (typeof console[m] === 'function') {
          this.debug[m] = console[m].bind(window.console, 'debug:');
        }
      });
    } else {
      Object.keys(console).forEach(m => {
        if (typeof console[m] === 'function') this.debug[m] = () => {};
      });
    }
    return this.debug;
  }
}
